import { Button } from '@chakra-ui/react';
import { useDisclaimerDrawer } from '@ui/components/DisclaimerDrawer';
import { useIsDesktop } from '@ui/components/MobileOrDesktop';
import { useTranslations } from '@ui/i18n';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import type { GardenToken, GardenType } from '@ui/utils/garden';
import { gardenTokenDict, getLpPoolUrl } from '@ui/utils/garden';
import { inTiaSelector } from '@veno-app/chakra';
import React from 'react';

import { useSupplyLcroModalStore } from '../UseLcroDirectly/useSupplyLcroModalStore';
import { useGardenModalStore } from './useGardenModalStore';

type GardenViewPlantGetMoreButtonProps = {
  gardenType: GardenType;
};

const GardenViewPlantGetMoreButton = ({
  gardenType,
}: GardenViewPlantGetMoreButtonProps) => {
  const sdk = useVenoSDK();
  const t = useTranslations();

  const openSupplyLcroModal = useSupplyLcroModalStore((s) => s.open);
  const openGardenModal = useGardenModalStore((s) => s.open);
  const closeGardenModal = useGardenModalStore((s) => s.close);
  const coinMode = useGardenModalStore((s) => s.coinMode);
  const isDesktop = useIsDesktop();
  const activeView = useGardenModalStore((s) => s.activeView);
  const gardenToken = gardenTokenDict[coinMode][gardenType] as Extract<
    GardenToken,
    { enabled: true }
  >;
  const assetName = gardenToken.name;

  const onClick = () => {
    if (sdk.chainType === 'zksync' || gardenType === 'VVS_TIA') {
      useDisclaimerDrawer.getState().onOpen({
        variant: 'wholeScreen',
        url: getLpPoolUrl(sdk.chainType, gardenType),
      });
      return;
    }
    if (isDesktop) {
      closeGardenModal();
    }
    openSupplyLcroModal({
      type: gardenType,
      coinMode,
      onBackward: () => {
        openGardenModal({
          type: gardenType,
          activeView,
          coinMode,
        });
      },
    });
  };

  return (
    <Button
      mt={1}
      variant="link"
      color="text-link"
      sx={{
        [inTiaSelector]: {
          color: 'brand-tiaTab',
        },
      }}
      onClick={onClick}
    >
      {t('Get more {coin}', {
        coin: assetName,
      })}
    </Button>
  );
};

export default GardenViewPlantGetMoreButton;
